module.exports = __webpack_public_path__ + "static/media/login.456ed8cb.png";